export default __webpack_public_path__ + "static/media/Dr.Ibrahim_Banaru.e47cf14f.png";